export default "__VITE_ASSET__CXkNCQ01__"